import BaseUpdateRequest from '@/models/Shared/BaseUpdateRequest';

export default class UpdateSkillRequest extends BaseUpdateRequest {
    name = '';
    description = '';
}